import React, { useState } from "react";
import { Font } from "@react-pdf/renderer";
import logo from "../../assests/AGP_Logo.png";
import { addLeadingZeros } from "../../utils/DataUtils";
import {
  Page,
  Text,
  View,
  Document,
  StyleSheet,
  Image,
  pdf,
} from "@react-pdf/renderer";

Font.register({
  family: "Open Sans",
  fonts: [
    {
      src: "https://cdn.jsdelivr.net/npm/open-sans-all@0.1.3/fonts/open-sans-regular.ttf",
    },
    {
      src: "https://cdn.jsdelivr.net/npm/open-sans-all@0.1.3/fonts/open-sans-700.ttf",
      fontWeight: "bold",
    },
  ],
});

const styles = StyleSheet.create({
  table: {
    display: "table",
    width: "98%",
    marginBottom: 10,
    marginLeft: 10,
  },

  tableRow: {
    flexDirection: "row",
    display: "flex",
    flexWrap: "wrap",
    alignItems: "center",
    marginTop: 5,
  },

  tableBorder: {
    display: "table",
    width: "100%",
    border: 1,
    borderColor: "black",
  },

  columnHeader: {
    flexDirection: "row",
    display: "flex",
    flexWrap: "wrap",
    textAlign: "center",
    fontSize: 8,
  },

  columnHeaderText: {
    fontWeight: "bold",
    fontFamily: "Open Sans",
  },

  text: {
    fontSize: 9,
    fontWeight: "normal",
    fontFamily: "Open Sans",
  },

  textBold: {
    fontSize: 9,
    fontWeight: "bold",
    fontFamily: "Open Sans",
  },

  textPadding: {
    fontSize: 9,
    padding: 2,
    overflowWrap: "break-word",
  },

  textBorder: {
    padding: 2,
    fontSize: 9,
    width: "30%",
    borderRightWidth: 1,
    borderColor: "black",
  },

  cell: {
    textAlign: "center",
    fontSize: 8,
    width: "90%",
  },
  page: {
    padding: 20,
  },
  sectionContainer: {
    display: "flex",
    flexDirection: "row",
    paddingHorizontal: 10,
    marginBottom: 20,
    marginVertical: 10,
  },
  sectionText: {
    display: "flex",
    flexDirection: "row",
    justifyContent: "space-between",
  },
  section: {
    padding: 10,
    flexGrow: 1,
  },
  logo: {
    alignSelf: "center",
    width: 70,
    height: 40,
  },

  pageFooter: {
    fontSize: 6,
    marginTop: "auto",
    color: "grey",
    textAlign: "justify",
  },
});

let sumQtde = "";
let sumMetragemItem = "";
let totalValue = "";
let subTotal = "";
let sumPesoLiquido = 0;
let sumPesoLiquidoView = 0;
let lenguagePdf = {};
let retex = [];
let addItem = 0;
let totalWeigthBox = [];
let totalWeigthPack = 0;
let listBox = [];

const sumValues = (data) => {
  retex = contarRepeticoes(data);
  sumQtde = somarValores(data, "qtde", true);
  sumMetragemItem = somarValores(data, "metragemItem", true);
  sumPesoLiquido = somarValores(data, "item_PesoLiquido", false);
  sumPesoLiquidoView = somarValores(data, "item_PesoLiquido", true);
  totalValue = somarValoresEQuantidade(data, "qtde", "vrUnitario");
  subTotal = sumSubTotal(data, "qtde", "vrUnitario");
  addItem = incotermValid(data);
  listBox = contarCaixas(data);

  totalWeigthBox = calculateTotalWeights(listBox, data);

  for (let i = 0; i < totalWeigthBox.length; i++) {
    totalWeigthPack += totalWeigthBox[i].boxTotalWeigth;
  }

  totalWeigthPack = Number(totalWeigthPack.toFixed(2));
};

const contarCaixas = (array) => {
  const contagem = {};

  array.forEach((obj) => {
    const box = obj.pkI_BoxNumber;
    contagem[box] = contagem[box] ? contagem[box] + 1 : 1;
  });

  const resultado = Object.keys(contagem).map((box) => ({
    chave: box,
    valor: contagem[box],
  }));

  return resultado;
};

const calculateTotalWeights = (listBox, data) => {
  const totalWeights = [];

  Object.entries(listBox).forEach((outerRow) => {
    let currentBoxTotalWeight = 0;
    const boxCode = outerRow[1].chave;

    for (let i = 0; i < data.length; i++) {
      if (boxCode === data[i].pkI_BoxNumber) {
        currentBoxTotalWeight = Number(data[i].pkB_BoxWeight);
        break;
      }
    }

    Object.entries(data).forEach((innerRow) => {
      if (innerRow[1].pkI_BoxNumber === boxCode) {
        currentBoxTotalWeight += Number(innerRow[1].item_PesoLiquido);
      }
    });

    currentBoxTotalWeight = Number(currentBoxTotalWeight.toFixed(2));

    totalWeights.push({
      boxCode: boxCode,
      boxTotalWeigth: currentBoxTotalWeight,
    });
  });

  return totalWeights;
};

function contarRepeticoes(array) {
  const contagem = {};
  array.forEach((obj) => {
    const retex = obj.retex;
    contagem[retex] = contagem[retex] ? contagem[retex] + 1 : 1;
  });

  const resultado = Object.keys(contagem).map((retex) => ({
    chave: retex,
    valor: contagem[retex],
  }));

  return resultado;
}

function incotermValid(array) {
  let incoterm = array[0].incoterm1;
  let trFrSeg = array[0].trFrSeg;
  let seguro = array[0].seguro;
  let impostos = array[0].impostos;

  if (incoterm === "CPT") {
    return trFrSeg / sumPesoLiquido;
  } else if (incoterm === "CFR") {
    return trFrSeg / sumPesoLiquido;
  } else if (incoterm === "CIF") {
    return (seguro + trFrSeg) / sumPesoLiquido;
  } else if (incoterm === "DAP") {
    return (seguro + trFrSeg) / sumPesoLiquido;
  } else if (incoterm === "DDP") {
    return (seguro + trFrSeg + impostos) / sumPesoLiquido;
  }

  return 0;
}

function somarValores(lista, atributo, replace) {
  let sum = 0;

  for (let i = 0; i < lista.length; i++) {
    sum += Number(lista[i][atributo]);
  }

  sum = Number(sum.toFixed(2));

  if (replace) {
    sum = sum.toString().replace(".", ",");
  }

  return sum;
}

function converterSlashParaPonto(texto) {
  return texto.replace(/\//g, ".");
}

function somarValoresEQuantidade(lista, atributo1, atributo2) {
  let sum = 0;

  for (let i = 0; i < lista.length; i++) {
    sum += lista[i][atributo1] * lista[i][atributo2];
  }

  return parseFloat(sum).toFixed(2).replace(".", ",");
}

function sumSubTotal(lista, atributo1, atributo2) {
  let sum = 0;

  for (let i = 0; i < lista.length; i++) {
    sum += lista[i][atributo1] * lista[i][atributo2];
  }

  sum = sum - lista[0].trFrSeg - lista[0].seguro - lista[0].impostos;
  return parseFloat(sum).toFixed(2).replace(".", ",");
}

const SectionOne = (data) => {
  return (
    <View style={styles.sectionContainer}>
      <View style={{ width: "38%" }}>
        <View
          style={[
            styles.sectionText,
            {
              borderTopWidth: 1,
              borderBottomWidth: 1,
              borderLeftWidth: 1,
              borderRightWidth: 1,
              borderBottomColor: "black",
            },
          ]}
        >
          <Text style={[{ fontSize: 12, fontWeight: "bold" }]}>
            {lenguagePdf.pg1_DataFaturamento}
          </Text>

          <Text style={[{ fontWeight: "normal !important", fontSize: 12 }]}>
            {converterSlashParaPonto(data[0].dtFaturamento)}{" "}
          </Text>
        </View>

        <View
          style={[
            styles.sectionText,
            {
              borderBottomWidth: 1,
              borderLeftWidth: 1,
              borderRightWidth: 1,
              borderBottomColor: "black",
            },
          ]}
        >
          <Text style={styles.textPadding}>
            {lenguagePdf.pg1_DataVencimento}:
          </Text>

          <Text style={styles.textPadding}>{data[0].condicaoPagamento} </Text>
        </View>

        <View
          style={[
            styles.sectionText,
            {
              borderBottomWidth: 1,
              borderLeftWidth: 1,
              borderRightWidth: 1,
              borderBottomColor: "black",
            },
          ]}
        >
          <Text style={styles.textPadding}>{lenguagePdf.pg1_Total} </Text>

          <Text style={styles.textPadding}>USD {totalValue}</Text>
        </View>
      </View>

      <View style={{ width: "35%", paddingHorizontal: 8 }}>
        <View style={styles.sectionText}>
          <Text style={styles.textBold}>{lenguagePdf.pg1_Vendedor}</Text>

          <Text style={styles.text}>{data[0].vendedor} </Text>
        </View>

        <View style={styles.sectionText}>
          <Text style={styles.textBold}>{lenguagePdf.pg1_Responsavel}</Text>

          <Text style={styles.text}>{data[0].responsavel} </Text>
        </View>

        <View style={styles.sectionText}>
          <Text style={styles.textBold}>{lenguagePdf.pg1_Email}</Text>

          <Text style={styles.text}>{data[0].emailResponsavel} </Text>
        </View>

        <View style={styles.sectionText}>
          <Text style={styles.textBold}>{lenguagePdf.pg1_NSap}</Text>

          <Text style={styles.text}>{data[0].pedidoVenda} </Text>
        </View>
      </View>

      <View
        style={{
          width: "26%",
          display: "flex",
          justifyContent: "center",
        }}
      >
        <Image style={styles.logo} src={logo} />

        <Text style={{ fontSize: 7, textAlign: "center" }}>
          {lenguagePdf.pg1_AGP}
        </Text>

        <Text
          style={{ fontSize: 10, textAlign: "center" }}
          render={({ pageNumber, totalPages }) =>
            `Pág ${pageNumber} de ${totalPages}`
          }
        />
      </View>
    </View>
  );
};

const SectionTwo = (data) => {
  return (
    <View style={[styles.sectionContainer]}>
      <View
        style={[
          styles.section,

          {
            width: "50%",
            borderWidth: 1,
            borderBottomColor: "black",
            display: "flex",
            gap: 3,
          },
        ]}
      >
        <Text style={{ fontSize: 12 }}>
          {lenguagePdf.pg1_ClienteDestinatarioInvoice}
        </Text>

        <Text style={{ fontSize: 10 }}>{data[0].cliente}</Text>

        <Text style={{ fontSize: 10 }}>{data[0].endereco}</Text>

        <Text style={{ fontSize: 10 }}>{data[0].pais}</Text>

        <Text style={{ fontSize: 10 }}>Atn</Text>
      </View>

      <View
        style={[
          styles.section,

          {
            width: "50%",
            borderBottomWidth: 1,
            borderTopWidth: 1,
            borderRightWidth: 1,
            borderBottomColor: "black",
            display: "flex",
            gap: 3,
          },
        ]}
      >
        <Text style={{ fontSize: 12 }}>
          {lenguagePdf.pg1_ClienteDestinatarioMercadoria}
        </Text>
        <Text style={{ fontSize: 10 }}>{data[0].cliente}</Text>
        <Text style={{ fontSize: 10 }}>{data[0].endereco_Dest_Invoice}</Text>
        <Text style={{ fontSize: 10 }}>{data[0].pais_Dest_Invoice}</Text>
        <Text style={{ fontSize: 10 }}>Atn</Text>
      </View>
    </View>
  );
};

const Table = (data) => {
  return (
    <View style={styles.table}>
      <View style={styles.tableRow}>
        <Text style={[styles.cell, { width: "5%" }]}>
          <Text style={styles.columnHeaderText}>{lenguagePdf.pg1_Item}</Text>
        </Text>
        <Text style={[styles.cell, { width: "10%" }]}>
          <Text style={styles.columnHeaderText}>{lenguagePdf.pg1_CodAGP}</Text>
        </Text>
        <Text style={[styles.cell, { width: "10%" }]}>
          <Text style={styles.columnHeaderText}>
            {lenguagePdf.pg1_CodCliente}
          </Text>
        </Text>
        <Text style={[styles.cell, { width: "10%" }]}>
          <Text style={styles.columnHeaderText}>{lenguagePdf.pg1_Pedido}</Text>
        </Text>
        <Text style={[styles.cell, { width: "10%" }]}>
          <Text style={styles.columnHeaderText}>
            {lenguagePdf.pg1_POCliente}
          </Text>
        </Text>
        <Text style={[styles.cell, { width: "22%" }]}>
          <Text style={styles.columnHeaderText}>
            {lenguagePdf.pg1_Descricao}
          </Text>
        </Text>
        <Text style={[styles.cell, { width: "5%" }]}>
          <Text style={styles.columnHeaderText}>{lenguagePdf.pg1_Quant}</Text>
        </Text>
        <Text style={[styles.cell, { width: "7%" }]}>
          <Text style={styles.columnHeaderText}>
            {lenguagePdf.pg1_Metragem}
          </Text>
        </Text>
        <Text style={[styles.cell, { width: "9%" }]}>
          <Text style={styles.columnHeaderText}>
            {lenguagePdf.pg1_PrecoUnitario}
          </Text>
        </Text>
        <Text style={[styles.cell, { width: "9%" }]}>
          <Text style={styles.columnHeaderText}>
            {lenguagePdf.pg1_TotalItem}
          </Text>
        </Text>
      </View>

      {!!data &&
        Object.entries(data).map((row, index) => {
        
          return (
          <View key={row[1].item} style={styles.tableRow}>
            <Text style={[styles.cell, { width: "5%" }]}>{row[1].item}</Text>

            <Text style={[styles.cell, { width: "10%" }]}>
              {row[1].material}
            </Text>

            <Text style={[styles.cell, { width: "10%" }]}>{`EXP${addLeadingZeros(row[1].id,6)}`}</Text>

            <Text style={[styles.cell, { width: "10%" }]}>
              {row[1].pedidoVenda} 
            </Text>

            <Text style={[styles.cell, { width: "10%" }]}>
              {row[1].pedido_Cliente}
            </Text>

            <Text style={[styles.cell, { width: "22%" }]}>
              {row[1].veiculo}
            </Text>

            <Text style={[styles.cell, { width: "5%" }]}>{row[1].qtde}</Text>

            <Text style={[styles.cell, { width: "7%" }]}>
              {row[1].metragemItem}
            </Text>

            <Text style={[styles.cell, { width: "9%" }]}>
              {Number(
                (row[1].vrUnitario - row[1].item_PesoLiquido * addItem).toFixed(
                  2
                )
              )
                .toString()
                .replace(".", ",")}
            </Text>

            <Text style={[styles.cell, { width: "9%" }]}>
              {Number(
                (
                  (row[1].vrUnitario - row[1].item_PesoLiquido * addItem) *
                  row[1].qtde
                ).toFixed(2)
              )
                .toString()
                .replace(".", ",")}
            </Text>
          </View>
        )})}

      <View style={[styles.tableRow, { marginTop: 1 }]}>
        <Text style={[styles.cell, { width: "5%" }]}></Text>
        <Text style={[styles.cell, { width: "10%" }]}></Text>
        <Text style={[styles.cell, { width: "10%" }]}></Text>
        <Text style={[styles.cell, { width: "10%" }]}></Text>
        <Text style={[styles.cell, { width: "10%" }]}></Text>
        <Text
          style={[
            {
              width: "22%",
              textAlign: "center",
              fontWeight: "bold",
              fontSize: 10,
              paddingTop: 8,
            },
          ]}
        >
          {lenguagePdf.pg1_SubtotalItem}
        </Text>

        <Text
          style={[
            styles.cell,

            {
              width: "5%",

              borderTopWidth: 1,

              borderColor: "black",

              paddingTop: 8,
            },
          ]}
        >
          {sumQtde}
        </Text>

        <Text
          style={[
            styles.cell,

            {
              width: "7%",

              borderTopWidth: 1,

              borderColor: "black",

              paddingTop: 8,
            },
          ]}
        >
          {sumMetragemItem}
        </Text>

        <Text style={[styles.cell, { width: "9%" }]}></Text>

        <Text
          style={[
            styles.cell,

            {
              width: "9%",

              borderTopWidth: 1,

              borderColor: "black",

              paddingTop: 8,
            },
          ]}
        >
          {subTotal}
        </Text>
      </View>
    </View>
  );
};

const Final = (data, NCM) => {
  return (
    <View wrap={false}>
      <View
        style={[styles.sectionText, { paddingHorizontal: 12, marginTop: 20 }]}
      >
        <View style={{ width: "35%", justifyContent: "space-around" }}>
          <View style={[styles.sectionText, { paddingRight: 4 }]}>
            <Text
              style={[styles.textBold, { width: "40%", textAlign: "left" }]}
            >
              {lenguagePdf.pg2_Incoterm}
            </Text>

            <Text style={[styles.text, { width: "55%" }]}>
              {data[0].incoterm1 + " " + data[0].incoterm2}
            </Text>
          </View>

          <View style={[styles.sectionText, { paddingRight: 4 }]}>
            <Text
              style={[styles.textBold, { width: "40%", textAlign: "left" }]}
            >
              {lenguagePdf.pg2_PesoBruto}
            </Text>

            <Text style={[styles.text, { width: "55%" }]}>
              {totalWeigthPack}
            </Text>
          </View>

          <View style={[styles.sectionText, { paddingRight: 4 }]}>
            <Text
              style={[styles.textBold, { width: "40%", textAlign: "left" }]}
            >
              {lenguagePdf.pg2_PesoLiquido}
            </Text>

            <Text style={[styles.text, { width: "55%" }]}>
              {sumPesoLiquidoView}
            </Text>
          </View>

          <View style={[styles.sectionText, { paddingRight: 4 }]}>
            <Text
              style={[styles.textBold, { width: "40%", textAlign: "left" }]}
            >
              {lenguagePdf.pg2_TipoEmbalagem}
            </Text>

            <Text style={[styles.text, { width: "55%" }]}>
              {data[0].embalagem}
            </Text>
          </View>

          <View style={[styles.sectionText, { paddingRight: 4 }]}>
            <Text
              style={[styles.textBold, { width: "40%", textAlign: "left" }]}
            >
              {lenguagePdf.pg2_QtdTotal}
            </Text>

            <Text style={[styles.text, { width: "55%" }]}>
              {listBox.length}
            </Text>
          </View>

          <View style={[styles.sectionText, { paddingRight: 4 }]}>
            <Text
              style={[styles.textBold, { width: "40%", textAlign: "left" }]}
            >
              {lenguagePdf.pg2_MetragemTotal}
            </Text>

            <Text style={[styles.text, { width: "55%" }]}>
              {sumMetragemItem}
            </Text>
          </View>

          <View style={[styles.sectionText, { paddingRight: 4 }]}>
            <Text
              style={[styles.textBold, { width: "40%", textAlign: "left" }]}
            >
              {lenguagePdf.pg2_QtdPeca}
            </Text>

            <Text style={[styles.text, { width: "55%" }]}>{sumQtde}</Text>
          </View>
        </View>

        <View style={{ width: "38%", justifyContent: "space-around" }}>
          <View style={[styles.sectionText, { paddingRight: 4 }]}>
            <Text style={[styles.textBold, { width: "60%" }]}>
              {lenguagePdf.pg2_Transportadora}
            </Text>

            <Text style={styles.text}></Text>
          </View>

          <View style={[styles.sectionText, { paddingRight: 4 }]}>
            <Text style={[styles.textBold, { width: "60%" }]}>
              {lenguagePdf.pg2_Modal}
            </Text>

            <Text style={styles.text}></Text>
          </View>

          <View style={[styles.sectionText, { paddingRight: 4 }]}>
            <Text style={[styles.textBold, { width: "60%" }]}>
              {lenguagePdf.pg2_PortoAeroporto}
            </Text>

            <Text style={styles.text}></Text>
          </View>

          <View style={[styles.sectionText, { paddingRight: 4 }]}>
            <Text style={[styles.textBold, { width: "60%" }]}>
              {lenguagePdf.pg2_TipoFrete}
            </Text>

            <Text style={[styles.text, { width: "40%", textAlign: "left" }]}>
              {data[0].tipo_Frete}
            </Text>
          </View>

          <View style={[styles.sectionText, { paddingRight: 4 }]}>
            <Text style={[styles.textBold, { width: "60%" }]}>
              {lenguagePdf.pg2_Seguro}
            </Text>

            <Text style={[styles.text, { width: "40%", textAlign: "left" }]}>
              {data[0].tipo_Seguro}
            </Text>
          </View>

          <View style={[styles.sectionText, { paddingRight: 4 }]}>
            <Text style={[styles.textBold, { width: "60%" }]}>
              {lenguagePdf.pg2_Conhecimento}
            </Text>

            <Text style={styles.text}></Text>
          </View>

          <View style={[styles.sectionText, { paddingRight: 4 }]}>
            <Text style={[styles.textBold, { width: "60%" }]}>
              {lenguagePdf.pg2_Embarque}
            </Text>

            <Text style={styles.text}></Text>
          </View>

          <View style={[styles.sectionText, { paddingRight: 4 }]}>
            <Text style={[styles.textBold, { width: "64%" }]}>
              {lenguagePdf.pg2_PartidaArancelaria}
            </Text>

            <Text style={[styles.text, { width: "36%", textAlign: "left" }]}>
              {NCM}
            </Text>
          </View>

          <View style={[styles.sectionText, { paddingRight: 4 }]}>
            <Text style={[styles.textBold, { width: "60%" }]}>
              {lenguagePdf.pg2_PackingList}
            </Text>

            <Text style={[styles.text, { width: "40%", textAlign: "left" }]}>
              {data[0].pedidoVenda}
            </Text>
          </View>
        </View>

        <View style={[styles.tableBorder, { width: "60%" }]}>
          <View
            style={[
              styles.sectionText,

              {
                borderBottomWidth: 1,

                borderBottomColor: "black",
              },
            ]}
          >
            <Text style={[styles.textBorder, styles.textBold]}>
              {lenguagePdf.pg2_Subtotal}
            </Text>

            <Text
              style={[
                styles.textPadding,

                { fontFamily: "Open Sans", fontWeight: "normal" },
              ]}
            >
              {subTotal}{" "}
            </Text>
          </View>

          <View
            style={[
              styles.sectionText,

              {
                borderBottomWidth: 1,

                borderBottomColor: "black",
              },
            ]}
          >
            <Text style={[styles.textBorder, styles.textBold]}>
              {lenguagePdf.pg2_Desconto}
            </Text>

            <Text
              style={[
                styles.textPadding,

                { fontFamily: "Open Sans", fontWeight: "normal" },
              ]}
            >
              {data[0].desconto}{" "}
            </Text>
          </View>

          <View
            style={[
              styles.sectionText,

              {
                borderBottomWidth: 1,

                borderBottomColor: "black",
              },
            ]}
          >
            <Text style={[styles.textBorder, styles.textBold]}>
              {lenguagePdf.pg2_Impostos}
            </Text>

            <Text
              style={[
                styles.textPadding,

                { fontFamily: "Open Sans", fontWeight: "normal" },
              ]}
            >
              {data[0].impostos}{" "}
            </Text>
          </View>

          <View
            style={[
              styles.sectionText,

              {
                borderBottomWidth: 1,

                borderBottomColor: "black",
              },
            ]}
          >
            <Text style={[styles.textBorder, styles.textBold]}>
              {lenguagePdf.pg2_TotalFreteSeguro}
            </Text>

            <Text
              style={[
                styles.textPadding,

                { fontFamily: "Open Sans", fontWeight: "normal" },
              ]}
            >
              {data[0].trFrSeg}{" "}
            </Text>
          </View>

          <View
            style={[
              styles.sectionText,

              {
                borderBottomWidth: 1,

                borderBottomColor: "black",
              },
            ]}
          >
            <Text style={[styles.textBorder, styles.textBold]}>
              {lenguagePdf.pg2_Seguro_1}
            </Text>

            <Text
              style={[
                styles.textPadding,

                { fontFamily: "Open Sans", fontWeight: "normal" },
              ]}
            >
              {data[0].seguro}{" "}
            </Text>
          </View>

          <View
            style={[
              styles.sectionText,

              {
                borderBottomWidth: 1,

                borderBottomColor: "black",
              },
            ]}
          >
            <Text style={[styles.textBorder, styles.textBold]}>
              {lenguagePdf.pg2_CustosDestino}
            </Text>

            <Text
              style={[
                styles.textPadding,

                { fontFamily: "Open Sans", fontWeight: "normal" },
              ]}
            >
              {data[0].custosDestino}{" "}
            </Text>
          </View>

          <View style={[styles.sectionText, { height: 28 }]}>
            <Text
              style={[
                styles.textBorder,
                styles.textBold,
                { textAlign: "center", fontSize: 12 },
              ]}
            >
              {lenguagePdf.pg2_Total_1}
            </Text>

            <Text
              style={[
                {
                  fontSize: 10,

                  textAlign: "center",

                  fontFamily: "Open Sans",

                  fontWeight: "normal",
                },
              ]}
            >
              {totalValue}
            </Text>
          </View>
        </View>
      </View>

      <View>
        <View
          style={[
            styles.tableBorder,

            { width: "96%", marginTop: 25, marginHorizontal: 10 },
          ]}
        >
          <View
            style={[
              styles.sectionText,

              {
                borderBottomWidth: 1,

                borderBottomColor: "black",
              },
            ]}
          >
            <Text style={styles.textBorder}>
              {lenguagePdf.pg2_CondicoesPagamento}
            </Text>

            <Text style={styles.textPadding}>{data[0].condicaoPagamento} </Text>
          </View>

          <View
            style={[
              styles.sectionText,

              {
                height: 40,
              },
            ]}
          >
            <Text style={styles.textBorder}>
              {lenguagePdf.pg2_InstrucoesPagamento}
            </Text>

            <Text style={styles.textPadding}>  {data[0].condicaoPagamento}</Text>
          </View>
        </View>

        <Text style={{ fontSize: 12, margin: 6, marginLeft: 15 }}>
          {lenguagePdf.pg2_Notas}
        </Text>

        <View
          style={[styles.tableBorder, { width: "96%", marginHorizontal: 10 }]}
        >
          <Text style={[styles.textPadding, { height: 50 }]}>
            {data[0].notas}{" "}
          </Text>
        </View>
      </View>

      <View style={styles.sectionContainer}>
        <View
          style={{
            width: "30%",

            justifyContent: "space-around",

            marginRight: 50,
          }}
        >
          <View style={[styles.sectionText, { paddingRight: 4 }]}>
            <Text style={styles.textBold}>{lenguagePdf.pg2_Tracking}</Text>

            <Text style={styles.text}>{data[0].pais_Dest_Invoice}</Text>
          </View>

          <View style={[styles.sectionText, { paddingRight: 4 }]}>
            <Text style={styles.textBold}>{lenguagePdf.pg2_Pais}</Text>

            <Text style={styles.text}>Brasil</Text>
          </View>
        </View>

        <View style={{ width: "30%", justifyContent: "space-around" }}>
          <View style={[styles.sectionText, { paddingRight: 4 }]}>
            <Text style={[styles.textBold, { width: 100 }]}>
              {lenguagePdf.pg2_ClienteFinal}
            </Text>

            <Text style={styles.text}>{data[0].cliente}</Text>
          </View>

          <View style={[styles.sectionText, { paddingRight: 4, marginTop: 2 }]}>
            <Text style={[styles.textBold, { width: 100 }]}>
              {lenguagePdf.pg2_Intermediario}
            </Text>

            <Text style={styles.text}></Text>
          </View>
        </View>
      </View>

      <View style={{ paddingHorizontal: 12 }}>
        <View style={[styles.tableBorder, { width: "35%" }]}>
          <View
            style={[
              styles.sectionText,

              {
                textAlign: "center",

                borderBottomWidth: 1,

                borderBottomColor: "black",
              },
            ]}
          >
            <Text
              style={{
                padding: 2,

                fontSize: 9,

                width: "65%",

                borderRightWidth: 1,

                borderColor: "black",

                fontFamily: "Open Sans",

                fontWeight: "bold",
              }}
            >
              Retex
            </Text>

            <Text
              style={{
                padding: 2,

                fontSize: 9,

                width: "35%",

                fontFamily: "Open Sans",

                fontWeight: "bold",
              }}
            >
              Quantidade
            </Text>
          </View>

          {!!retex &&
            Object.entries(retex).map((row) => {
              return (
                <View
                  style={[
                    styles.sectionText,

                    {
                      borderBottomWidth: 1,

                      borderBottomColor: "black",

                      textAlign: "center",
                    },
                  ]}
                >
                  <Text
                    style={{
                      padding: 2,

                      fontSize: 9,

                      width: "65%",

                      borderRightWidth: 1,

                      borderColor: "black",
                    }}
                  >
                    {row[1].chave}
                  </Text>

                  <Text
                    style={{
                      padding: 2,

                      fontSize: 9,

                      width: "35%",
                    }}
                  >
                    {row[1].valor}{" "}
                  </Text>
                </View>
              );
            })}
        </View>
      </View>
    </View>
  );
};

const MyDocument = ({ data, lenguage, NCM, nameInvoice }) => {
  lenguagePdf = lenguage;

  sumValues(data);

  return (
    <Document>
      <Page size="A4" style={styles.page}>
        <Text style={{ textAlign: "center", marginBottom: 8 }} fixed>
          {nameInvoice != ""
            ? lenguagePdf.pg1_NProforma +
              " " +
              data[0].pedidoVenda +
              "/" +
              nameInvoice
            : lenguagePdf.pg1_NProforma + " " + data[0].pedidoVenda}
        </Text>
        <View fixed>
          {SectionOne(data)}

          {SectionTwo(data)}
        </View>
        {Table(data)}{" "}
        <View
          fixed
          style={[
            styles.pageFooter,
            { display: "flex", justifyContent: "center", alignItems: "center" },
          ]}
        >
          <Text style={{ marginBottom: 12 }} fixed>
            {lenguagePdf.pg1_TextoCompliance}
          </Text>

          <Text
            style={{
              textAlign: "center",
              fontSize: 8,
              borderTopWidth: 1,
              borderTopColor: "grey",
              width: "40%",
              padding: 2,
            }}
            fixed
          >
            {lenguagePdf.pg1_AGPNIF} <br />
            {lenguagePdf.pg1_AGPEnderec}
          </Text>
        </View>
      </Page>

      <Page size="A4" style={styles.page}>
        <Text style={{ textAlign: "center", marginBottom: 8 }} fixed>
        {nameInvoice != ""
            ? lenguagePdf.pg1_NProforma +
              " " +
              data[0].pedidoVenda +
              "/" +
              nameInvoice
            : lenguagePdf.pg1_NProforma + " " + data[0].pedidoVenda}
        </Text>

        <View fixed>
          {SectionOne(data)}

          {SectionTwo(data)}
        </View>

        {Final(data, NCM)}
        <View
          fixed
          style={[
            styles.pageFooter,
            { display: "flex", justifyContent: "center", alignItems: "center" },
          ]}
        >
          <Text style={{ marginBottom: 12 }} fixed>
            {lenguagePdf.pg1_TextoCompliance}
          </Text>

          <Text
            style={{
              textAlign: "center",
              fontSize: 8,
              borderTopWidth: 1,
              borderTopColor: "grey",
              width: "40%",
              padding: 2,
            }}
            fixed
          >
            {lenguagePdf.pg1_AGPNIF} <br />
            {lenguagePdf.pg1_AGPEnderec}
          </Text>
        </View>
      </Page>
    </Document>
  );
};

const generatePDF = async (invoice, lenguage, NCM, nameInvoice) => {

  const pdfBlob = await pdf(
    <MyDocument
      data={invoice}
      NCM={NCM}
      lenguage={lenguage}
      nameInvoice={nameInvoice}
    />
  ).toBlob();

  const url = URL.createObjectURL(pdfBlob);

  window.open(url, "_blank");

  URL.revokeObjectURL(url);
};

export default generatePDF;
